import {fetchHeaders} from "../../utils/headers";
import Constants from "../../utils/constants";
import {bilanXlsxQuery} from "./bilanXlsxQuery";

export const synthesesService = {
    fetchInterventionPDF,
    fetchSynthese
};

function fetchInterventionPDF(interventionId) {
    let url = Constants.API_ROUTE_SYNTHESE_INTERVENTION.replace(':id', interventionId);
    window.open(url + '?token=' + Constants.API_ROUTE_SYNTHESE_INTERVENTION_TOKEN, '_blank');
}

/** Déclenche le téléchargement d'un blob sous le nom donné par Content-Disposition (ou un repli). */
function telechargerBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

function filenameFromResponse(response, fallback) {
    const contentDisposition = response.headers.get('Content-Disposition');
    const match = contentDisposition && contentDisposition.match(/filename="?([^";]+)"?/);
    return match && match[1] ? match[1] : fallback;
}

/**
 * Classeur xlsx du read model BilanActes (REP-03 R10) :
 * GET /api/bilans/actes/{clientId}/xlsx?dateDebut&dateFin[&patrimoine][&conteneur], JWT en en-tête, réponse binaire.
 */
function fetchBilanActesXlsx(values) {
    const url = Constants.API_ROUTE_BILAN_ACTES_XLSX.replace(':clientId', values.client) + '?' + bilanXlsxQuery(values);

    return fetch(url, fetchHeaders())
        .then((response) => {
            if (!response.ok) {
                return response.text().then((text) => {
                    let message = response.statusText;
                    try {
                        const data = text && JSON.parse(text);
                        message = data?.detail || data?.message || data?.['hydra:description'] || message;
                    } catch (e) { /* corps non JSON */ }
                    return Promise.reject(message);
                });
            }
            const filename = filenameFromResponse(response, `Bilan_${values.dateDebut}_${values.dateFin}.xlsx`);
            return response.blob().then((blob) => telechargerBlob(blob, filename));
        });
}

/**
 * Synthèse = classeur xlsx du read model BilanActes, global ou restreint à un patrimoine / PAV (01/10).
 * Le PDF passe par « Mes exports » (SynthesePage.handlePdfExport) ; le CSV n'est plus proposé.
 */
function fetchSynthese(values) {
    return fetchBilanActesXlsx(values);
}
